import React,{useEffect} from 'react'
import { Button, Header, Icon, Modal } from 'semantic-ui-react'
import { Route } from 'react-router-dom'
const ModalBuilder =({isTimeUp,setPage}) =>{
   const [open, setOpen] = React.useState(false)

   useEffect(() => {
     
    if(isTimeUp){
      setOpen(true)
    }else{
      setOpen(false)
    }

   }, [isTimeUp])

  return (
    <Modal
      basic
      // onClose={() => setOpen(false)}
      // onOpen={() => setOpen(true)}
      open={open}
      size='small'
      // trigger={<Button>Basic Modal</Button>}
    >
      <Header icon>
        <Icon name='warning sign' />
        Your Session is Over!
      </Header>
      <Modal.Content>
        <p>
          Please Click to start a new booking!
        </p>
      </Modal.Content>
      <Modal.Actions>
        {/* <Button basic color='red' inverted onClick={() => setOpen(false)}>
          <Icon name='Start' /> No
        </Button> */}
        <Route render={({ history}) => (
        <Button color='green' inverted onClick={() =>{ setOpen(false);setPage(0);history.push('/')}}>
          <Icon name='checkmark' /> New Session
        </Button>
         )} />
      </Modal.Actions>
    </Modal>
  )
}

export default ModalBuilder